// Columns are sized to their content (header + sample values). Narrow
// tables (few/short columns) then stretch those widths to fill the grid;
// wide tables keep the content-sized widths and scroll horizontally
// instead — see the shouldStretch logic in CompareDataTab.
const HEADER_FONT = '600 13px Inter, sans-serif'
const CELL_FONT = '400 13px Inter, sans-serif'
const HEADER_CELL_OVERHEAD = 56 // cell padding + sort icon + resize handle
const DATA_CELL_OVERHEAD = 48 // cell padding + extra buffer to prevent clipping

let measureCanvas: HTMLCanvasElement | null = null

function measureTextWidth(text: string, font: string): number {
  if (!measureCanvas) measureCanvas = document.createElement('canvas')
  const ctx = measureCanvas.getContext('2d')
  if (!ctx) return text.length * 8
  ctx.font = font
  return ctx.measureText(text).width
}

export function computeHeaderWidth(label: string): number {
  return Math.ceil(measureTextWidth(label, HEADER_FONT)) + HEADER_CELL_OVERHEAD
}

export function computeContentWidth(values: string[]): number {
  if (values.length === 0) return 0
  const widest = Math.max(...values.map((v) => measureTextWidth(v, CELL_FONT)))
  return Math.ceil(widest) + DATA_CELL_OVERHEAD
}
